import axios from "axios";

const apiUrl = "https://mapcard.pro/demo/server.php";

const CheckoutPay = (totalPrice, email) => {
  const response = getSessionID(totalPrice);
  return response;
};

const getSessionID = async (totalPrice) => {
  const request = {
    merchant_order_id: "demo_" + generateOrderID(7),
    amount: totalPrice * 100,
    type: "Pay",
    add_card: false,
    payment_type: "TwoStep",
    lifetime: 604800,
  };
  const response = await axios.post(apiUrl, request);
  return response;
};

const generateOrderID = (length) => {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
};

export default CheckoutPay;
